import styled from 'styled-components';

import { breakpoints } from '../../ui/variables';

export const PageWithMenuStyle = styled.div`
  min-height: 100vh;
  width: 100%;

  @media (min-width: ${breakpoints.ipadLandscape.width}px) {
    column-gap: 16px;
    display: grid;
    grid-template-columns: calc(40% - 8px) calc(60% - 8px);
    grid-template-row: auto;
  }

  @media (min-width: ${breakpoints.hd.width}px) {
    grid-template-columns: 380px calc(100% - 404px);
  }

  @media (min-width: ${breakpoints.fullHd.width}px) {
    margin: 0 auto;
    max-width: ${breakpoints.fullHd.width}px;
  }
`;
